import api from './api'

// System Tracker — owner-only integrity, provenance and settlement-watchdog APIs.
// Backend: server/systemTracker/router.js (mounted at /api/system-tracker).
// Every endpoint here is READ-ONLY except acknowledgeFinding, which writes only to
// the watchdog's own table. No call in this file moves money — remedial actions go
// through the existing manual-settle endpoints, which carry their own owner +
// transaction-password gates.

// The axios instance is based at /api, so paths are relative to that.
const BASE = '/system-tracker'

export const getAlerts = async () => {
  const res = await api.get(`${BASE}/alerts`)
  return res.data
}

export const runScan = async () => {
  const res = await api.post(`${BASE}/scan`)
  return res.data
}

// Bell badge polls this — skipLoader so the background poll never flashes the
// global LoaderOverlay over whatever the owner is actually doing.
export const getAlertCount = async () => {
  const res = await api.get(`${BASE}/alerts`, { skipLoader: true })
  return res.data
}

export const searchAccounts = async (q) => {
  const res = await api.get(`${BASE}/search`, { params: { q }, skipLoader: true })
  return res.data
}

export const getAccountReport = async (idOrUsername) => {
  const res = await api.get(`${BASE}/${encodeURIComponent(idOrUsername)}`)
  return res.data
}

export const getProvenance = async (idOrUsername) => {
  const res = await api.get(`${BASE}/${encodeURIComponent(idOrUsername)}/provenance`)
  return res.data
}

export const getWatchdog = async (all = false) => {
  const res = await api.get(`${BASE}/watchdog`, { params: all ? { all: '1' } : {} })
  return res.data
}

export const runWatchdogScan = async () => {
  const res = await api.post(`${BASE}/watchdog/scan`)
  return res.data
}

export const acknowledgeFinding = async (id) => {
  const res = await api.post(`${BASE}/watchdog/${id}/acknowledge`)
  return res.data
}

export default {
  getAlerts, runScan, getAlertCount, searchAccounts,
  getAccountReport, getProvenance, getWatchdog, runWatchdogScan, acknowledgeFinding,
}
